
document.addEventListener("DOMContentLoaded", () => {
    const allColors = ['blue', 'teal', 'yellow', 'coral', 'coral-red', 'pink', 'purple', 'white', 'black', 'grey', 'transparent'];
    const colorSelector = allColors.map((c) => `[class*="${c}"]`).join(', ');
    const colorElements = document.querySelectorAll(colorSelector);
    colorElements.forEach((colorElement) => {
      const foundColors = allColors.filter((color) => colorElement.className.includes(color));
      if (foundColors.length === 0) return;
      if (colorElement.className.includes('all')) return;

      if (foundColors.length > 1) {
        let combinationClass = '';
        const joinedColors = foundColors.join('-');
        combinationClass = joinedColors;

        colorElement.classList.add(combinationClass);
        console.log(`Combination Added: .${combinationClass}`);
      } else {
        let singleClass = '';
        const colorName = foundColors[0];
        singleClass = 'solid-' + colorName;
        colorElement.classList.add(singleClass);
        console.log(`Single Added: .${singleClass}`);
      }
    });

    const bgColors = document.querySelectorAll('[class*="bg-color"]');
    bgColors.forEach((bgColor) => {
      bgColor.classList.add('bg-color');
    });
    const bgFades = document.querySelectorAll('[class*="bg-fade"]');
    bgFades.forEach((bgFade) => {
      bgFade.classList.add('bg-fade');
    });

    // Create a merged array using spread syntax
    const bgs = [...bgColors, ...bgFades];

    const bgFadeRights = Array.from(bgs).filter((el) => Array.from(el.classList).some((cls) => cls.includes('right')));
    const bgFadeLefts = Array.from(bgs).filter((el) => Array.from(el.classList).some((cls) => cls.includes('left')));
    const bgFadeTops = Array.from(bgs).filter((el) => Array.from(el.classList).some((cls) => cls.includes('top')));
    const bgFadeBottoms = Array.from(bgs).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('bottom'))
    );
    const bgFadeDiags = Array.from(bgs).filter((el) => Array.from(el.classList).some((cls) => cls.includes('diag')));
    bgFadeRights.forEach((el) => el.classList.add('bg-right'));
    bgFadeLefts.forEach((el) => el.classList.add('bg-left'));
    bgFadeTops.forEach((el) => el.classList.add('bg-top'));
    bgFadeBottoms.forEach((el) => el.classList.add('bg-bottom'));
    bgFadeDiags.forEach((el) => el.classList.add('bg-diag'));

    const strokeTexts = document.querySelectorAll(
      '[class*="stroke-text"]:not([class*="bold"]):not([class*="gradient"])'
    );
    strokeTexts.forEach((strokeText) => {
      strokeText.classList.add('stroke-text-color');
    });

    const strokeTextsBolds = document.querySelectorAll('[class*="stroke-text-bold"]');
    const strokeTextsGradients = document.querySelectorAll('[class*="stroke-text-gradient"]');
    strokeTextsBolds.forEach((strokeTextBold) => {
      strokeTextBold.classList.add('stroke-text-bold');
    });
    strokeTextsGradients.forEach((strokeTextGradient) => {
      strokeTextGradient.classList.add('stroke-text-gradient');
    });

    const fieldFonts = document.querySelectorAll('[class*="fields"]:not([class*="recipient"])');
    fieldFonts.forEach((fieldFont) => {
      fieldFont.classList.add('fields');
    });

    const textclips = document.querySelectorAll('[class*="text-all"]:not([class*="accent"])');
    textclips.forEach((textclip) => {
      textclip.classList.add('text-clip');
    });

    const customButtons = document.querySelectorAll('[class*="custom"][class*="button"]');
    customButtons.forEach((customButton) => {
      customButton.classList.add('custom-button');
    });
    const roundButtons = Array.from(customButtons).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('round'))
    );
    const squareButtons = Array.from(customButtons).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('square'))
    );
    const largeButtons = Array.from(customButtons).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('large'))
    );
    const xlargeButtons = Array.from(customButtons).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('xlarge'))
    );
    const smallButtons = Array.from(customButtons).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('small'))
    );
    const xsmallButtons = Array.from(customButtons).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('xsmall'))
    );
    const gelButtons = Array.from(customButtons).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('gel'))
    );
    const candyButtons = Array.from(customButtons).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('candy'))
    );
    const softButtons = Array.from(customButtons).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('soft'))
    );
    const clayButtons = Array.from(customButtons).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('clay'))
    );
    const squishButtons = Array.from(customButtons).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('squish'))
    );
    const neoButtons = Array.from(customButtons).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('neo') && !cls.includes('color'))
    );
    const neoColorButtons = Array.from(customButtons).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('neo-button-color'))
    );
    const glassButtons = Array.from(customButtons).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('glass') && !cls.includes('flat'))
    );
    const gummyButtons = Array.from(customButtons).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('gummy'))
    );

    squareButtons.forEach((el) => el.classList.add('square-button'));
    roundButtons.forEach((el) => el.classList.add('round-button'));
    largeButtons.forEach((el) => el.classList.add('button-lg'));
    xlargeButtons.forEach((el) => el.classList.add('button-xl'));
    xsmallButtons.forEach((el) => el.classList.add('button-xs'));
    smallButtons.forEach((el) => el.classList.add('button-sm'));
    neoButtons.forEach((el) => el.classList.add('neo-button'));
    neoColorButtons.forEach((el) => el.classList.add('neo-button-color'));
    gelButtons.forEach((el) => el.classList.add('gel-button'));
    candyButtons.forEach((el) => el.classList.add('candy-button'));
    softButtons.forEach((el) => el.classList.add('soft-button'));
    clayButtons.forEach((el) => el.classList.add('clay-button'));
    glassButtons.forEach((el) => el.classList.add('glass-button'));
    gummyButtons.forEach((el) => el.classList.add('gummy-button'));
    squishButtons.forEach((el) => el.classList.add('squish-button'));


    const underlines = document.querySelectorAll('[class*="underline-"]:not([class*="link"])');
    underlines.forEach((underline) => { underline.classList.add('underline'); });
    underlines.forEach((underline) => { underline.classList.add('underline-color'); });

    const thinUnderlines = Array.from(underlines).filter((el) => Array.from(el.classList).some((cls) => cls.includes('thin')) );
    const boldUnderlines = Array.from(underlines).filter((el) => Array.from(el.classList).some((cls) => cls.includes('bold')) );
    const topUnderlines = Array.from(underlines).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('top'))
    );
    const bottomUnderlines = Array.from(underlines).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('bottom'))
    );
    const leftUnderlines = Array.from(underlines).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('left'))
    );
    const rightUnderlines = Array.from(underlines).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('right'))
    );
    const clayUnderlines = Array.from(underlines).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('clay'))
    );
    const cloudUnderlines = Array.from(underlines).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('cloud'))
    );
    const candyUnderlines = Array.from(underlines).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('candy'))
    );
    const softUnderlines = Array.from(underlines).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('soft'))
    );
    const glassUnderlines = Array.from(underlines).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('glass'))
    );
    const paintUnderlines = Array.from(underlines).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('paint'))
    );

    thinUnderlines.forEach((el) => el.classList.add('underline-thin'));
    boldUnderlines.forEach((el) => el.classList.add('underline-bold'));
    topUnderlines.forEach((el) => el.classList.add('underline-top'));
    bottomUnderlines.forEach((el) => el.classList.add('underline-bottom'));
    rightUnderlines.forEach((el) => el.classList.add('underline-right'));
    leftUnderlines.forEach((el) => el.classList.add('underline-left'));
    clayUnderlines.forEach((el) => el.classList.add('underline-clay'));
    cloudUnderlines.forEach((el) => el.classList.add('cloud'));
    candyUnderlines.forEach((el) => el.classList.add('candy'));
    softUnderlines.forEach((el) => el.classList.add('soft'));
    glassUnderlines.forEach((el) => el.classList.add('glass'));
    paintUnderlines.forEach((el) => el.classList.add('paint'));

    const highlights = document.querySelectorAll('[class*="highlight-color"]:not([class*="static"])');
    highlights.forEach((highlight) => { highlight.classList.add('highlight-color'); });

    const statichighlights = document.querySelectorAll('[class*="highlight-static"]');
    statichighlights.forEach((statichighlight) => { statichighlight.classList.add('highlight-static'); });

    const colorHighlights = Array.from(highlights).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('highlight-color') && !cls.includes('highlight-static') && !cls.includes('static'))
    );

    colorHighlights.forEach((colorHighlight) => {
      colorHighlight.classList.add('highlight-move');
    });
    const clayHighlights = Array.from(highlights).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('clay'))
    );
    const cloudHighlights = Array.from(highlights).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('cloud'))
    );
    const candyHighlights = Array.from(highlights).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('candy'))
    );
    const softHighlights = Array.from(highlights).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('soft'))
    );
    const paintHighlights = Array.from(highlights).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('paint'))
    );
    cloudHighlights.forEach((el) => el.classList.add('cloud'));
    candyHighlights.forEach((el) => el.classList.add('candy'));
    softHighlights.forEach((el) => el.classList.add('soft'));
    paintHighlights.forEach((el) => el.classList.add('paint'));
    clayHighlights.forEach((el) => el.classList.add('highlight-clay'));

    const counterlists = document.querySelectorAll('ol[class*="custom"]');
    counterlists.forEach((counterlist) => {
      counterlist.classList.add("custom-counter-list");
    });
    const squareCounter = Array.from(counterlists).filter((el) => Array.from(el.classList).some((cls) => cls.includes('square')));
    const clayCounter = Array.from(counterlists).filter((el) => Array.from(el.classList).some((cls) => cls.includes('clay')));
    const candyCounter = Array.from(counterlists).filter((el) => Array.from(el.classList).some((cls) => cls.includes('candy')));
    const paintCounter = Array.from(counterlists).filter((el) => Array.from(el.classList).some((cls) => cls.includes('paint')));
    const softCounter = Array.from(counterlists).filter((el) => Array.from(el.classList).some((cls) => cls.includes('soft')));
    const smallCounter = Array.from(counterlists).filter((el) => Array.from(el.classList).some((cls) => cls.includes('small')));
    const largeCounter = Array.from(counterlists).filter((el) => Array.from(el.classList).some((cls) => cls.includes('large')));
    const xlargeCounter = Array.from(counterlists).filter((el) => Array.from(el.classList).some((cls) => cls.includes('xlarge')));

    smallCounter.forEach((el) => el.classList.add('counter-sm'));
    largeCounter.forEach((el) => el.classList.add('counter-lg'));
    xlargeCounter.forEach((el) => el.classList.add('counter-xl'));
    clayCounter.forEach((el) => el.classList.add('clay'));
    candyCounter.forEach((el) => el.classList.add('candy'));
    paintCounter.forEach((el) => el.classList.add('counter-paint'));
    softCounter.forEach((el) => el.classList.add('soft'));
    squareCounter.forEach((el) => el.classList.add('counter-square'));

    const lists = document.querySelectorAll('ul[class*="color"]'); 
      lists.forEach((list) => { list.classList.add('color-list');});
    const smallLists = Array.from(lists).filter((el) => Array.from(el.classList).some((cls) => cls.includes('small')));
    const largeLists = Array.from(lists).filter((el) => Array.from(el.classList).some((cls) => cls.includes('large')));
    const squareLists = Array.from(lists).filter((el) => Array.from(el.classList).some((cls) => cls.includes('square')));
    const clayLists = Array.from(lists).filter((el) => Array.from(el.classList).some((cls) => cls.includes('clay')));
    const cloudLists = Array.from(lists).filter((el) => Array.from(el.classList).some((cls) => cls.includes('cloud')));
    const shadowLists = Array.from(lists).filter((el) => Array.from(el.classList).some((cls) => cls.includes('shadow')));
    const candyLists = Array.from(lists).filter((el) => Array.from(el.classList).some((cls) => cls.includes('candy')));
    const softLists = Array.from(lists).filter((el) => Array.from(el.classList).some((cls) => cls.includes('soft')));
    const glassLists = Array.from(lists).filter((el) => Array.from(el.classList).some((cls) => cls.includes('glass')));
    const paintLists = Array.from(lists).filter((el) => Array.from(el.classList).some((cls) => cls.includes('paint')));
    const liquidLists = Array.from(lists).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('liquid'))
    );
    const stripeLists = Array.from(lists).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('stripe'))
    );
    const paintstripeLists = Array.from(stripeLists).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('paint'))
    );
    const turnLists = Array.from(lists).filter((el) => Array.from(el.classList).some((cls) => cls.includes('turn')));
    const cubeLists = Array.from(lists).filter((el) => Array.from(el.classList).some((cls) => cls.includes('cube')));
    smallLists.forEach((el) => el.classList.add('list-sm'));
    largeLists.forEach((el) => el.classList.add('list-lg'));
    clayLists.forEach((el) => el.classList.add('clay'));
    cloudLists.forEach((el) => el.classList.add('cloud'));
    shadowLists.forEach((el) => el.classList.add('shadow'));
    candyLists.forEach((el) => el.classList.add('candy'));
    glassLists.forEach((el) => el.classList.add('glass'));
    paintLists.forEach((el) => el.classList.add('paint'));
    liquidLists.forEach((el) => el.classList.add('liquid'));
    liquidLists.forEach((el) => el.classList.add('liquid-list'));
    squareLists.forEach((el) => el.classList.add('square-list'));
    stripeLists.forEach((el) => el.classList.add('stripe-list'));
    paintstripeLists.forEach((el) => el.classList.add('stripe-list-paint'));
    turnLists.forEach((el) => el.classList.add('turn-list'));
    cubeLists.forEach((el) => el.classList.add('cube-list'));

    const colorTexts = document.querySelectorAll(
      '[class*="text-color"]:not([class*="accent"]):not([class*="gradient"])'
    );
    colorTexts.forEach((colorText) => {
      colorText.classList.add('text-color');
    });
    const gradientTexts = document.querySelectorAll(
      '[class*="text-gradient"]:not([class*="accent"]):not([class*="button"])'
    );
    gradientTexts.forEach((gradientText) => {
      gradientText.classList.add('text-gradient');
    });
    const accentTexts = document.querySelectorAll('[class*="accent-text"]');
    accentTexts.forEach((accentText) => {
      accentText.classList.add('accent-text');
    });
    const softclayTexts = Array.from(accentTexts).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('soft-clay'))
    );
    softclayTexts.forEach((el) => el.classList.add('soft-clay-text'));

    const brightclayTexts = Array.from(accentTexts).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('bright-clay'))
    );
    brightclayTexts.forEach((el) => el.classList.add('bright-clay-text'));

    const clayTexts = Array.from(accentTexts).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('clay') && !cls.includes('bright') && !cls.includes('soft'))
    );
    clayTexts.forEach((el) => el.classList.add('clay-text'));

    const softTexts = Array.from(accentTexts).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('soft') && !cls.includes('clay'))
    );
    softTexts.forEach((el) => el.classList.add('soft-text'));

    const mattTexts = Array.from(accentTexts).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('matt'))
    );
    mattTexts.forEach((el) => el.classList.add('matt-text'));

    const candyTexts = Array.from(accentTexts).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('candy'))
    );
    candyTexts.forEach((el) => el.classList.add('candy-text'));

    const gummyTexts = Array.from(accentTexts).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('gummy'))
    );
    gummyTexts.forEach((el) => el.classList.add('gummy-text'));

    const gelTexts = Array.from(accentTexts).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('gel'))
    );
    gelTexts.forEach((el) => el.classList.add('gel-text'));

    const textlinks = document.querySelectorAll('[class*="text-link"]');
    textlinks.forEach((el) => el.classList.add('text-link'));

    const gradientTextlinks = Array.from(textlinks).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('gradient'))
    );
    const candyTextlinks = Array.from(textlinks).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('candy'))
    );
    gradientTextlinks.forEach((el) => el.classList.add('gradient-text-link'));
    candyTextlinks.forEach((el) => el.classList.add('candy-text-link'));
    const underlinelinks = document.querySelectorAll('[class*="underline-link"]');
    underlinelinks.forEach((el) => el.classList.add('underline-link'));
    const circlelinks = document.querySelectorAll('[class*="link-circle"]');
    const claycirclelinks = Array.from(circlelinks).filter((el) =>
      Array.from(el.classList).some((cls) => cls.includes('clay'))
    );
    claycirclelinks.forEach((el) => el.classList.add('link-circle-clay'));

    const svgCode = `
          <svg viewBox="0 0 70 36">
            <path d="M6.9739 30.8153H63.0244C65.5269 30.8152 75.5358 -3.68471 35.4998 2.81531C-16.1598 11.2025 0.894099 33.9766 26.9922 34.3153C104.062 35.3153 54.5169 -6.68469 23.489 9.31527" />
          </svg>
        `;

    // Loop through each link
    circlelinks.forEach((circlelink) => {
      circlelink.insertAdjacentHTML('beforeend', svgCode);
      circlelink.classList.add('link-circle');
    });

    const observes = document.querySelectorAll('[class*="observe"]');

    const animationsObserverOptions = {
      root: null, // observes intersection with the browser viewport
      rootMargin: '0px',
      threshold: 0.2, // callback when 20% of the target is visible
    };
    const animationsObserved = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('inview');
        }
      });
    };
    // Create a new IntersectionObserver instance
    const animationsObserver = new IntersectionObserver(animationsObserved, animationsObserverOptions);
    observes.forEach((element) => {
      animationsObserver.observe(element);
    });
    underlines.forEach((element) => {
      animationsObserver.observe(element);
    });
    highlights.forEach((element) => {
      animationsObserver.observe(element);
    });
    lists.forEach((element) => {
      animationsObserver.observe(element);
    });
  });